'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/4/19.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VerificationCodeInput = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(VerificationCodeInput, _Component);

  function VerificationCodeInput() {
    (0, _classCallCheck3.default)(this, VerificationCodeInput);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(VerificationCodeInput).call(this));
  }

  (0, _createClass3.default)(VerificationCodeInput, [{
    key: 'onBtnClick',
    value: function onBtnClick() {
      var click = this.props.click;

      if (click) {
        click();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./GoeasyInputField.scss');
      var _props = this.props;
      var formProps = _props.formProps;
      var labelStyle = _props.labelStyle;
      var clicked = _props.clicked;
      var waitingTime = _props.waitingTime;

      var currentLabelStyle = {};
      if (labelStyle) {
        currentLabelStyle = (0, _extends3.default)({}, labelStyle);
      }
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'p',
          { className: styles.label, style: currentLabelStyle },
          '验证码：'
        ),
        _react2.default.createElement(
          'div',
          { className: styles.input },
          _react2.default.createElement('input', (0, _extends3.default)({ ref: 'verifyCode', type: 'text',
            className: styles.field + ' ' + styles.verifyCode,
            placeholder: '请输入验证码' }, formProps)),
          _react2.default.createElement(
            'div',
            { style: { disabled: clicked }, className: styles.verifyCodeBtn,
              onClick: function onClick() {
                return clicked ? '' : _this2.onBtnClick();
              } },
            clicked ? '请稍候(' + waitingTime + ')' : '发送验证码'
          )
        )
      );
    }
  }]);
  return VerificationCodeInput;
}(_react.Component), _class.propTypes = {
  label: _react.PropTypes.string,
  labelStyle: _react.PropTypes.object,
  clicked: _react.PropTypes.bool,
  waitingTime: _react.PropTypes.number,
  formProps: _react.PropTypes.object,
  click: _react.PropTypes.func.isRequired
}, _temp);
exports.default = VerificationCodeInput;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GoeasyInputField/VerificationCodeInput.js
 ** module id = 130
 ** module chunks = 0
 **/